var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16647 3.8344C6.16616 4.45321 5.92004 5.04656 5.48225 5.4839C5.04447 5.92125 4.45088 6.16678 3.83207 6.16647C3.21326 6.16616 2.61991 5.92004 2.18256 5.48225C1.74522 5.04447 1.49969 4.45088 1.5 3.83207C1.50031 3.21326 1.74643 2.61991 2.18421 2.18256C2.622 1.74522 3.21559 1.49969 3.8344 1.5C4.45321 1.50031 5.04656 1.74643 5.4839 2.18421C5.92125 2.622 6.16678 3.21559 6.16647 3.8344ZM6.23646 7.89423H1.57V22.5003H6.23646V7.89423ZM13.6095 7.89423H8.96635V22.5003H13.5628V14.8356C13.5628 10.5658 19.1276 10.1691 19.1276 14.8356V22.5003H23.7357V13.249C23.7357 6.05097 15.4994 6.31929 13.5628 9.85414L13.6095 7.89423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6dc7e3e3f1d055dcf3e184a5f9c51105.svg";
export { ForwardRef as ReactComponent };